import { render, staticRenderFns } from "./EditBusinessCustomHighlightsView.vue?vue&type=template&id=f1f1f9d2&scoped=true&"
import script from "./EditBusinessCustomHighlightsView.vue?vue&type=script&lang=ts&"
export * from "./EditBusinessCustomHighlightsView.vue?vue&type=script&lang=ts&"
import style0 from "./EditBusinessCustomHighlightsView.vue?vue&type=style&index=0&id=f1f1f9d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f1f9d2",
  null
  
)

export default component.exports